module.exports = __webpack_public_path__ + "static/img/Home_slogan.b31f451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/Home_slogan.jpg
// module id = c8p6
// module chunks = 7